const messages = {
  title: "Ceníky a produktové brožury",
  description:
    "Zde si stáhněte nejnovější brožury a letáky o našich pneumatikách Bridgestone a Firestone pro osobní automobily, SUV a užitková vozidla.",
  brochureCategories: {
    products: "Produkty",
    brand_and_solutions: "Značka a řešení",
    season_and_promotions: "Sezóna a akce",
    format: "Formát",
    cars_and_vans: "Auto, SUV, Utility",
    summer: "Letní",
    winter: "Zimní",
    promotions: "Akce",
    all_season: "Všechna roční období",
    truck_and_buses: "Těžká nákladní vozidla a autobusy",
    motorcycle: "Motocykl",
    agriculture: "Zemědělství",
    construction_machinery: "Stavební stroje",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiály",
    brochures: "Produktové brožury",
    price_list: "Ceníky",
    materials: "Materiály",
    video_in_store: "Video s titulky",
    video_online: "Video bez titulků",
    banner_website: "Prapor",
    banner_social_media: "Sociální sítě",
    logos: "Loga",
  },
  searchMedia: "Zadejte klíčové slovo",
  searchResults: "Výsledky hledání",
};

export default {
  messages,
};
